
import { useQuery } from 'react-query';
import { jobsApply } from 'services/pharmaJobs';
import { getErrorText } from 'utils/geterrortext';
import { useRouter } from 'next/router';
import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './JobApplyButton.module.scss';


const JobApplyButton = ({ activeJob, toast }) => {
    const router = useRouter();
    const { data, isLoading, refetch } = useQuery(
        ['jobs-job-apply', activeJob],
        () => jobsApply.GET(activeJob),
        {
            enabled: false,
            onSuccess: (data) => {
                if (data?.data?.link) {
                    window.open(data.data.link, '_blank');
                } else {
                    toast('No apply URL found for this job');
                }
            },
            onError: (error) => {
                if (error.response.status === 401) {
                    router.replace('/login?next=/jobs');
                    return;
                }
                if (error.response.status !== 436)
                    toast(getErrorText(error), 'alert');
            }
        }
    );

    const handleApply = () => {
        refetch()
    };

    return (
        <div className={classes.wrapper}>
            <ActionButton kind='primary' onClick={handleApply}>Apply</ActionButton>
        </div>
    );
}

export default JobApplyButton;